import React from 'react'
import {Redirect} from 'react-router-dom'

class NoRoute extends React.PureComponent {
  render() {
    return <Redirect to="/" />
  }
}

export default NoRoute



// WEBPACK FOOTER //
// ./src/js/components/NoRoute.js